module.exports = __webpack_public_path__ + "static/features-phone-tutoring-a34f57152e88efbf6c5e47b89f402d6f.png";